import { Controller as BaseController } from "@hotwired/stimulus"

export class Controller extends BaseController {
  static targets = ["link"]

  connect() {
    if (!this.hasLinkTarget) return

    this.linkTarget.click()

    setTimeout(() => this.element.remove(), 200)
  }
}
